import { FaqStep } from '@/components/FaqSteps/FaqStep';

const PLATFORM_STEPS_FAQ = [
  {
    title: 'multibanking-platform.how-to-save-money.item1.question',
    text: 'multibanking-platform.how-to-save-money.item1.answer',
  },
  {
    title: 'multibanking-platform.how-to-save-money.item2.question',
    text: 'multibanking-platform.how-to-save-money.item2.answer',
  },
  {
    title: 'multibanking-platform.how-to-save-money.item3.question',
    text: 'multibanking-platform.how-to-save-money.item3.answer',
  },
  {
    title: 'multibanking-platform.how-to-save-money.item4.question',
    text: 'multibanking-platform.how-to-save-money.item4.answer',
  },
];

export const FaqSteps = () => {
  return (
    <ul>
      <li className="divide-y border-b border-blue-900 border-opacity-10">
        {PLATFORM_STEPS_FAQ.map((step, index) => (
          <FaqStep
            key={index}
            title={step.title}
            text={step.text}
            step={index + 1}
            className="py-3 first:pt-0"
          />
        ))}
      </li>
    </ul>
  );
};
